import { render, staticRenderFns } from "./input-phone.vue?vue&type=template&id=58a0abe6"
import script from "./input-phone.vue?vue&type=script&lang=js"
export * from "./input-phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports